import {z} from 'zod';

export default z.object({
    text: z.string(),
    level: z.number(),
});
